module.exports = __webpack_public_path__ + "static/media/shoes.f30fe0b2.jpg";